// extracted by mini-css-extract-plugin
module.exports = {"columnTableHead":"SlaDataTable_columnTableHead__14c9z"};